import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBranch = id => {
  return http.get(
    `${getBaseUrl()}/branch/${id}`
  );
};

export const getBranches = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/branch`
    );
  }
  return http.get(
    `${getBaseUrl()}/branch?${paginate}`
  );
};

export const getFieldBranches = () => {
  return http.get(
    `${getBaseUrl()}/field_branches`
  );
};

export const getFieldBranchesByFieldId = (id) => {
  return http.get(
    `${getBaseUrl()}/field_branches/${id}`
  );
};

export const getAgentFieldBranches = () => {
  return http.get(
    `${getBaseUrl()}/agent_field_branches`
  );
};

export const updateBranch = data => {

  return http.put(
    `${getBaseUrl()}/branch/${data.id}`,
    data
  );
};
export const submitBranch = data => {

  return http.post(
    `${getBaseUrl()}/branch`,
    data
  );
};
